import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {ModalDirective} from 'ng-uikit-pro-standard';
import { DashboardTileModel } from '../../shared/model/dashboard-tile-model';
import { ApplicationType } from '../../shared/enums/enums';

@Component({
  selector: 'app-application-modal',
  templateUrl: './application-modal.component.html',
  styleUrls: ['./application-modal.component.scss'],
})
export class ApplicationModalComponent implements OnInit {

  @ViewChild('modal') modal: ModalDirective;
  @Output() activated: EventEmitter<string> = new EventEmitter<string>();

  public model: DashboardTileModel;

  ngOnInit() {
  }

  public show(application: DashboardTileModel) {
    this.model = application;
    this.modal.show();
  }

  public close() {
    this.modal.hide();
  }

  public activate() {      
    this.activated.emit(this.model.type);
    this.modal.hide();
  }
}
